import { Pagination } from '../BaseModel'
import TransactionBaseApi from './base'
import {
  NonceLimitResult,
  GetNonceLimitDTO,
  GetFeeLevelDTO,
  FeeLevelModel,
  CreateTxDTO,
  CheckAddrDTO,
  DestinationCheckResultModel,
  GetTxInitDataDTO,
  TXInitDataModel,
  GetFeeExpressionDTO,
  TxModel,
  CreateSpeedTxDTO,
  CurrentFlowStatResult,
  GetFlowStatQueryDTO,
} from './models'

class TxApi extends TransactionBaseApi {
  async checkAddr(dto: CheckAddrDTO) {
    return this.post<DestinationCheckResultModel>('/createTxCheck', dto)
  }

  async getTxInitData(dto: GetTxInitDataDTO) {
    return this.post<TXInitDataModel>('/queryTxConfirmData', dto)
  }

  async getFeeExpression(dto: GetFeeExpressionDTO) {
    return this.post<{ expression: string }>('/queryFeeExpression', dto)
  }

  async getFeeLevel(dto: GetFeeLevelDTO) {
    return this.post<FeeLevelModel>('/queryFeeLevel', dto)
  }

  async createTx(dto: CreateTxDTO) {
    return this.post<TxModel>('/create', dto)
  }

  async createSpeedTx(dto: CreateSpeedTxDTO) {
    return this.post<TxModel>('/createReplaceTx', dto)
  }

  async getNonceLimit(dto: GetNonceLimitDTO) {
    return this.post<NonceLimitResult>('/queryNonceLimit', dto)
  }
  async getCurrentFlowStat(statTimeZone: number) {
    return this.post<CurrentFlowStatResult>('/currentFlowStat', {
      statTimeZone,
    })
  }
  async getFlowStatQueryByPage(dto: GetFlowStatQueryDTO) {
    return this.post<Pagination<CurrentFlowStatResult>>('/flowStatQueryByPage', dto)
  }
}

export default new TxApi()
